import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category/caibiao' },
    { label: '关于我们', path: '/about' },
  ],
  热门分类: [
    { label: '才艺表演', path: '/category/caibiao' },
    { label: '游戏直播', path: '/category/youxi' },
    { label: '聊天互动', path: '/category/liaotian' },
    { label: '户外直播', path: '/category/huwai' },
  ],
  帮助支持: [
    { label: '常见问题', path: '/#faq' },
    { label: '联系我们', path: '/about#contact' },
    { label: '用户协议', path: '/' },
    { label: '隐私政策', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/20 text-background-50">
                <i className="ri-live-line text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-serif">
                直播互动
              </span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              探索全新直播互动体验，与真实主播实时连线，畅享高清视频直播娱乐内容。安全可靠，随时随地开启沉浸式直播互动新体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; 2025 直播互动体验平台 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors duration-200" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line text-lg"></i>
              </div>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors duration-200" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line text-lg"></i>
              </div>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors duration-200" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-vidicon-line text-lg"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}